import { ApolloError } from '@apollo/client'
import { Button, Text } from '@factorialco/deprecated-design-system'

import ModalComponent from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import {
  InMemoryAdditionalCompensation,
  useContractFlow,
} from 'modules/contracts/lib/contractFlowContext'
import { removeAdditionalCompensationFromList } from 'modules/contracts/components/FlowPage/Steps/RoleLevelSalary/_AdditionalCompensations/lib/additionalCompensationList'

type DeleteAdditionalCompensationProps = {
  additionalCompensation: InMemoryAdditionalCompensation
  onClose?: () => void
  onError?: (error: ApolloError) => void
}

function DeleteAdditionalCompensation({
  additionalCompensation,
  onClose,
}: DeleteAdditionalCompensationProps) {
  const { additionalCompensations, setAdditionalCompensations } = useContractFlow()

  const onDelete = () => {
    const withoutRemovedCompensation = removeAdditionalCompensationFromList(
      additionalCompensations ?? [],
      additionalCompensation
    )
    setAdditionalCompensations(withoutRemovedCompensation)

    track(trackingEvents.compensations.deleteCompensation, {
      type: 'contract',
      compensationId: additionalCompensation.id || additionalCompensation.tmpID,
    })

    onClose?.()
  }

  return (
    <ModalComponent
      title="Delete additional compensation"
      onClose={onClose}
      illustration={'alert'}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t(
              'contract_versions.additional_compensation.delete_additional_compensation_form_modal.cancel'
            )}
          </Button>
          <Button onClick={onDelete}>
            {i18n.t(
              'contract_versions.additional_compensation.delete_additional_compensation_form_modal.delete'
            )}
          </Button>
        </>
      }
    >
      <Text.Normal size="300">
        {i18n.t(
          'contract_versions.additional_compensation.delete_additional_compensation_form_modal.new_hint'
        )}
      </Text.Normal>
    </ModalComponent>
  )
}

export { DeleteAdditionalCompensation }
